var React = require('react');

function ChevronSmallDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Chevron/Small—down"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"d":"M14.9360472,10.0541181 C15.4082049,9.58196037 16.1737239,9.58196037 16.6458817,10.0541181 C17.1180394,10.5262759 17.1180394,11.2917949 16.6458817,11.7639526 L13.562355,14.8474794 C12.9756325,15.4342018 12.0243675,15.4342018 11.437645,14.8474794 L8.35411832,11.7639526 C7.88196056,11.2917949 7.88196056,10.5262759 8.35411832,10.0541181 C8.82627608,9.58196037 9.59179507,9.58196037 10.0639528,10.0541181 L12.5,12.4901653 L14.9360472,10.0541181 Z","id":"path-1","key":2})]);
}

ChevronSmallDown.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = ChevronSmallDown;

ChevronSmallDown.default = ChevronSmallDown;
